export const KEYS_STORAGE = {
	auth: 'auth',
	user: 'user',
	menu: 'menu',
	jwt: 'jwt',
	url: 'url',
	permissions: 'permissions'
};
